import React, { useState } from 'react';
import useCurrentUser from '../../../customHook/useCurrentUser';
import { useUpdateAndVerifyGoogleSheetMutation } from '../../../features/apis/intergration';
import ReactToastify from '../../../customHook/useReactToastify';
interface GoogleSheetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SheetModal: React.FC<GoogleSheetModalProps> = ({ isOpen, onClose }) => {
  const [sheetUrl, setSheetUrl] = useState('');
  const [loading, setLoading] = useState(false);

  const [verifySheet] = useUpdateAndVerifyGoogleSheetMutation();
  const user = useCurrentUser();

  const handleSubmit = async () => {
    if (!user?._id || !user?.companyId) {
      ReactToastify({
        success: false,
        message: 'User or company info missing.',
      });
      return;
    }

    setLoading(true);
    try {
      const payload = {
        employeeId: user._id,
        companyId: user.companyId,
        googleSheetUrl: sheetUrl,
      };

      const res = await verifySheet(payload).unwrap();
      onClose(); // ✅ Close modal after success
      setSheetUrl('');
      ReactToastify({
        success: true,
        message: res.message || 'Sheet verified successfully',
      });
    } catch (err: any) {
      ReactToastify({
        success: false,
        message: err?.data?.message || 'Failed to verify sheet.',
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-lg h-60">
        <h2 className="text-xl font-semibold my-4">Track Google Sheet</h2>
        <input
          type="text"
          placeholder="Paste Google Sheet URL"
          value={sheetUrl}
          onChange={(e) => setSheetUrl(e.target.value)}
          className="w-full border px-3 py-2 rounded mb-4"
        />
        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded border border-gray-300 text-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="px-4 py-2 rounded bg-[#6E3EF5] text-white hover:bg-[#6E3EF5]"
          >
            {loading ? 'Verifying...' : 'Submit'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SheetModal;
